import deepOrange from 'material-ui/colors/deepOrange';
import amber from 'material-ui/colors/amber';

export default {
    direction: 'rtl',
    palette: {
        primary: {
            light: amber[300],
            main: amber[500],
            dark: amber[700],
        },
        secondary: {
            light: deepOrange[300],
            main: deepOrange['A400'],
            dark: deepOrange[700],
        }
    },
    status: {
        danger: 'orange',
    },

    typography: {
        fontFamily: 'IRANSans',
        button: {
            fontWeight: 400,
            textAlign: 'capitalize'
        },
    },
};



// WEBPACK FOOTER //
// ./containers/themes/amberTheme.js